import { nsPayluddSubscription } from '@/app/i18n/namespaces';
import PAYLUDD_PERSONALIZATION_INITIALIZATION_STATUS from '../enums/PayluddPackageStatus';
import SUBSCRIPTION_STATUS from '@/app/modules/subscriptions/enums/SubscriptionStatus';

export default {
    POS_TERMINAL: {
        key: 'posTerminal',
        DETAILS: {
            key: 'details',
            parentKeys: ['posTerminal'],
            enableSorting: false
        },
        DIRECT_PROVIDER: {
            key: 'directProvider',
            parentKeys: ['posTerminal'],
            type: 'text',
            entity: 'keys.provider_legal_name',
            namespace: nsPayluddSubscription,
            placeholder: 'filter.placeholder.provider_legal_name',
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        LAST_CONNECTION_DATE: {
            key: 'lastConnectionDate',
            parentKeys: ['posTerminal'],
            type: 'date',
            entity: 'keys.last_connection_date',
            namespace: nsPayluddSubscription,
            filter: 'date',
            enableSorting: true,
            isNested: true
        },
        SERIAL_NUMBER: {
            key: 'serialNumber',
            parentKeys: ['posTerminal'],
            type: 'text',
            entity: 'keys.serial_number',
            namespace: nsPayluddSubscription,
            placeholder: 'filter.placeholder.serial_number',
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        MANUFACTURER: {
            key: 'manufacturer',
            parentKeys: ['posTerminal'],
            type: 'text',
            entity: 'keys.manufacturer',
            namespace: nsPayluddSubscription,
            placeholder: 'filter.placeholder.manufacturer',
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        MODEL: {
            key: 'model',
            parentKeys: ['posTerminal'],
            type: 'text',
            entity: 'keys.model',
            namespace: nsPayluddSubscription,
            placeholder: 'filter.placeholder.model',
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        LABEL: {
            key: 'label',
            parentKeys: ['posTerminal'],
            type: 'text',
            entity: 'keys.pos_label',
            namespace: nsPayluddSubscription,
            placeholder: 'filter.placeholder.pos_label',
            filter: 'input',
            enableSorting: true,
            isNested: true
        }
    },
    VERSION: {
        key: 'version',
        PAX: {
            key: 'paxApplication',
            parentKeys: ['version'],
            type: 'text',
            entity: 'keys.version_pax',
            namespace: nsPayluddSubscription,
            placeholder: 'filter.placeholder.version_pax',
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        PAYLUDD: {
            key: 'payluddApplication',
            parentKeys: ['version'],
            type: 'text',
            entity: 'keys.version_payludd',
            placeholder: 'filter.placeholder.version_payludd',
            namespace: nsPayluddSubscription,
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        ANDROID: {
            key: 'android',
            parentKeys: ['version'],
            type: 'text',
            entity: 'keys.version_android',
            namespace: nsPayluddSubscription,
            placeholder: 'filter.placeholder.version_android',
            filter: 'input',
            enableSorting: true,
            isNested: true
        }
    },
    PACKAGE: {
        key: 'package',
        LABEL: {
            key: 'label',
            parentKeys: ['package'],
            type: 'text',
            entity: 'keys.package_label',
            namespace: nsPayluddSubscription,
            placeholder: 'filter.placeholder.package_label',
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        CODE: {
            key: 'code',
            parentKeys: ['package'],
            type: 'text',
            entity: 'keys.package_code',
            namespace: nsPayluddSubscription,
            placeholder: 'filter.placeholder.package_code',
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        VERSION: {
            key: 'version',
            parentKeys: ['package'],
            type: 'text',
            entity: 'keys.package_version',
            placeholder: 'filter.placeholder.package_version',
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        DOWNLOADED_AT: {
            key: 'downloadedAt',
            parentKeys: ['package'],
            type: 'date',
            entity: 'keys.download_date',
            namespace: nsPayluddSubscription,
            filter: 'date',
            enableSorting: true,
            isNested: true
        },
        STATUS: {
            key: 'initializationStatus',
            parentKeys: ['package'],
            type: 'select',
            entity: 'keys.package_initialization_status',
            namespace: nsPayluddSubscription,
            enum: PAYLUDD_PERSONALIZATION_INITIALIZATION_STATUS,
            enableSorting: true,
            filter: 'select',
            isNested: true
        },
        END_BILLING_DATE: {
            key: 'endBillingDate',
            parentKeys: ['package'],
            type: 'date',
            entity: 'keys.end_billing_date',
            namespace: nsPayluddSubscription,
            filter: 'date',
            enableSorting: true,
            isNested: true
        }
    },
    ORGANIZATION: {
        key: 'merchantOrganization',
        type: 'text',
        entity: 'keys.organization',
        namespace: nsPayluddSubscription,
        placeholder: 'filter.placeholder.organization',
        filter: 'input',
        enableSorting: true,
        isNested: false
    },
    CONTRACT_ACCESS: {
        key: 'contractsAccess',
        EMAIL: {
            key: 'email',
            parentKeys: ['contractsAccess'],
            type: 'text',
            entity: 'keys.email_merchant',
            namespace: nsPayluddSubscription,
            placeholder: 'filter.placeholder.email_merchant',
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        LABEL: {
            key: 'label',
            parentKeys: ['contractsAccess'],
            type: 'text',
            entity: 'keys.label_merchant',
            namespace: nsPayluddSubscription,
            placeholder: 'filter.placeholder.label_merchant',
            filter: 'input',
            enableSorting: true,
            isNested: true
        }
    },
    POS_TERMINAL_SUBSCRIPTION: {
        key: 'posTerminalSubscription',
        UUID: {
            key: 'uuid',
            parentKeys: ['posTerminalSubscription']
        },
        STATUS: {
            key: 'status',
            parentKeys: ['posTerminalSubscription'],
            entity: 'keys.subscriptions_status',
            namespace: nsPayluddSubscription,
            type: 'select',
            filter: 'select',
            enum: SUBSCRIPTION_STATUS,
            enableSorting: true,
            isNested: true
        }
    },
    CONTRACT: {
        key: 'contract',
        UUID: {
            key: 'uuid',
            parentKeys: ['contract'],
            type: 'text',
            entity: 'keys.contract.uuid',
            namespace: nsPayluddSubscription,
            enableSorting: false
        },
        CREATED_AT: {
            key: 'createdAt',
            parentKeys: ['contract'],
            type: 'date',
            entity: 'keys.contract.created_at',
            namespace: nsPayluddSubscription,
            enableSorting: false
        },
        UPDATED_AT: {
            key: 'updatedAt',
            parentKeys: ['contract'],
            type: 'date',
            entity: 'keys.contract.updated_at',
            namespace: nsPayluddSubscription,
            enableSorting: false
        },
        LABEL: {
            key: 'label',
            parentKeys: ['contract'],
            type: 'text',
            entity: 'keys.contract.label',
            namespace: nsPayluddSubscription,
            enableSorting: false
        },
        PROVIDER: {
            key: 'provider',
            parentKeys: ['contract'],
            type: 'text',
            entity: 'keys.contract.provider',
            namespace: nsPayluddSubscription,
            enableSorting: false
        },
        PROFILES: {
            key: 'profiles',
            UUID: {
                key: 'uuid',
                parentKeys: ['contract', 'profiles'],
                type: 'text',
                entity: 'keys.contract.profiles.uuid',
                namespace: nsPayluddSubscription,
                enableSorting: false
            },
            APPLICATION: {
                key: 'application',
                parentKeys: ['contract', 'profiles'],
                type: 'text',
                entity: 'keys.contract.profiles.application',
                namespace: nsPayluddSubscription,
                enableSorting: false,
                sortOptions: true
            },
            NUMBER: {
                key: 'contractNumber',
                parentKeys: ['contract', 'profiles'],
                type: 'text',
                entity: 'keys.contract.profiles.number',
                namespace: nsPayluddSubscription,
                enableSorting: false
            },
            BANK_CODE: {
                key: 'bankCode',
                parentKeys: ['contract', 'profiles'],
                type: 'text',
                entity: 'keys.contract.profiles.bank_code',
                namespace: nsPayluddSubscription,
                enableSorting: false
            },
            RANK: {
                key: 'rank',
                parentKeys: ['contract', 'profiles'],
                type: 'text',
                entity: 'keys.contract.profiles.rank',
                namespace: nsPayluddSubscription,
                enableSorting: false
            },
            LABEL: {
                key: 'contractLabel',
                parentKeys: ['contract', 'profiles'],
                type: 'text',
                namespace: nsPayluddSubscription,
                entity: 'keys.contract.profiles.label',
                enableSorting: false
            },
            CREATED_AT: {
                key: 'createdAt',
                parentKeys: ['contract', 'profiles'],
                type: 'date',
                entity: 'keys.contract.profiles.created_at',
                namespace: nsPayluddSubscription,
                enableSorting: false
            },
            UPDATED_AT: {
                key: 'updatedAt',
                parentKeys: ['contract', 'profiles'],
                type: 'date',
                entity: 'keys.contract.profiles.updated_at',
                namespace: nsPayluddSubscription,
                enableSorting: false
            }
        }
    }
};